import React, { Component } from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import moment from 'moment';
import { connect } from 'react-redux';
import momentLocalizer from 'react-widgets-moment';
import {
  Button,
  Row,
  Col,
  ControlLabel,
  FormControl,
} from 'react-bootstrap';
import { DateTimePicker } from 'react-widgets';

import linkWithCredentials from '../../../utils/linkWithCredentials';
import { getApiServerUrl } from '../../configuration/selectors';
import { downloadingFileAndUpdatingCredentials } from '../../../utils/downloadUpdatingCredentials';

momentLocalizer();

const propTypes = exact({
  apiServerUrl: PropTypes.string.isRequired,
});


class ExportTool extends Component {
  constructor(props) {
    super(props);
    this.state = {
      numberOfGroups: '',
      indexGroup: '',
      invoiceMonth: null,
    };

    this.onDateChange = this.onDateChange.bind(this);
    this.handleDeferredDownload = this.handleDeferredDownload.bind(this);
  }

  onDateChange(e, dateName) {
    if (dateName === 'invoiceMonth') {
      this.setState({ [dateName]: e });
    } else {
      this.setState({ [dateName]: e.target.value });
    }
  }

  handleDeferredDownload() {
    const { numberOfGroups, indexGroup, invoiceMonth } = this.state;

    if (!numberOfGroups || !indexGroup || !invoiceMonth) {
      return;
    }

    const { apiServerUrl } = this.props;
    const invoiceMonthStr = moment(invoiceMonth).format('YYYY-MM-DD');
    const pdfLinkCreds = linkWithCredentials(`${apiServerUrl}/deferred_jobs`);
    const pdfUrl = `${pdfLinkCreds}&date=${invoiceMonthStr}&number_of_groups=${numberOfGroups}&index_group=${indexGroup}`;
    downloadingFileAndUpdatingCredentials(pdfUrl);
  }

  render() {
    const maxDate = new Date();
    const { numberOfGroups, indexGroup, invoiceMonth } = this.state;
    return (
      <React.Fragment>
        <Row>
          <Col md={3}>
            <ControlLabel>Invoice Month</ControlLabel>
            <DateTimePicker
              placeholder="Select the invoice month."
              time={false}
              onChange={(e) => { return this.onDateChange(e, 'invoiceMonth'); }}
              max={maxDate}
              value={invoiceMonth}
              footer={false}
              views={['year', 'decade']}
            />
          </Col>
          <Col md={2}>
            <ControlLabel>Number of Groups</ControlLabel>
            <FormControl
              name="numberOfGroups"
              type="text"
              value={numberOfGroups}
              placeholder="Enter in the number of groups to be created."
              onChange={(e) => { return this.onDateChange(e, 'numberOfGroups'); }}
            />
          </Col>
          <Col md={2}>
            <ControlLabel>Index of Group</ControlLabel>
            <FormControl
              name="indexGroup"
              type="text"
              value={indexGroup}
              placeholder="Enter the index of the group to be exported"
              onChange={(e) => { return this.onDateChange(e, 'indexGroup'); }}
            />
          </Col>
        </Row>
        <br />
        <Row>
          <Col md={12}>
            <Button
              bsStyle="primary"
              onClick={this.handleDeferredDownload}
            >
              Export Deferred Jobs
            </Button>
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}

ExportTool.propTypes = propTypes;

const mapStateToProps = (state) => {
  return { apiServerUrl: getApiServerUrl(state) };
};

const withRedux = connect(mapStateToProps, {});

export default withRedux(ExportTool);
